module.exports = __webpack_public_path__ + "static/media/truck9.50c99a8f.svg";